import axios from "axios";

const API = axios.create({
  baseURL: "https://chatappapi.pino10.shop",
});

export const userChats = (id) => API.get(`/chat/${id}`);
